import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { newBorder, textSecondary } from "../../../utils/colors";

const TreatmentPlanPreviewFooter = ({ tenant }) => {
  const infoItems = [];

  if (tenant?.companyName) {
    infoItems.push(tenant.companyName);
  }

  if (tenant?.companyCode) {
    infoItems.push(tenant.companyCode);
  }

  // Build address string from available parts
  const addressParts = [];
  if (tenant?.address?.street) addressParts.push(tenant.address.street);
  if (tenant?.address?.zip) addressParts.push(tenant.address.zip);
  if (tenant?.address?.city) addressParts.push(tenant.address.city);
  if (tenant?.address?.country) addressParts.push(tenant.address.country);

  if (addressParts.length > 0) {
    infoItems.push(addressParts.join(", "));
  }

  if (tenant?.phone && tenant.phone.length > 4) {
    infoItems.push(tenant.phone);
  }

  if (tenant?.supportEmail) {
    infoItems.push(tenant.supportEmail);
  }

  if (tenant?.iban) {
    infoItems.push(tenant.iban);
  }

  if (tenant?.bankName) {
    infoItems.push(tenant.bankName);
  }

  // LOG
  // console.log("tenant", tenant);

  return (
    <Flex
      w="100%"
      align="center"
      justify="center"
      borderTop={`1px solid ${newBorder}`}
      p="1rem 0rem 0"
      m="3rem 0 0"
      wrap="wrap"
    >
      {infoItems.map((item, index) => (
        <Flex key={index} align="center">
          <Text
            fontSize="xs"
            fontWeight="500"
            color={textSecondary}
            opacity="0.8"
          >
            {item}
          </Text>
          {/* Add separator if it's not the last item */}
          {index < infoItems.length - 1 && (
            <Text fontSize="xs" fontWeight="300" color={textSecondary} mx={1}>
              |
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default TreatmentPlanPreviewFooter;
